import { useState, useEffect } from 'react';
import { getPortalBackendBaseUrl } from './apiUrlResolver';

interface Guide {
  name: string;
  content: string;
}

interface UseGuidesReturn {
  guides: Guide[];
  loading: boolean;
  error: string | null;
}

let cachedGuides: Guide[] | null = null;

const useGuides = (): UseGuidesReturn => {
  const [guides, setGuides] = useState<Guide[]>(cachedGuides || []);
  const [loading, setLoading] = useState(!cachedGuides);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cachedGuides) return;

    const baseUrl = getPortalBackendBaseUrl();
    
    fetch(`${baseUrl}/v1/guides`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch guides');
        return res.json();
      })
      .then(data => {
        const guidesData = data.guides || [];
        cachedGuides = guidesData;
        setGuides(guidesData);
        setLoading(false);
        return data;
      })
      .catch((error_: Error) => {
        setError(error_.message);
        setGuides([]);
        setLoading(false);
      });
  }, []);

  return { guides, loading, error };
};

export default useGuides;
